<template>
  <main class="main-layout">
    <router-view></router-view>
  </main>
</template>

<script>
export default {
  name: 'Main'
}
</script>

<style scoped>
.main-layout {
  position: relative;
  width: 100%;
  height: 100%;
}
.brand {
  position: absolute;
  bottom: 30px;
  color: #999;
  font-size: 12px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
